import { buildModelManager } from "../builder.js";
const DefaultReplyButtonSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  customerId: true,
  flowNodeId: true,
  messageSkeletonId: true,
  title: true,
  trackingId: true,
  updatedAt: true,
  whatsappId: true
};
const modelApiIdentifier = "replyButton";
const pluralModelApiIdentifier = "replyButtons";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultReplyButtonSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultReplyButtonSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultReplyButtonSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultReplyButtonSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultReplyButtonSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultReplyButtonSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultReplyButtonSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByWhatsappId",
    findByField: "whatsappId",
    findByVariableName: "whatsappId",
    modelApiIdentifier,
    defaultSelection: DefaultReplyButtonSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByWhatsappId",
    findByField: "whatsappId",
    findByVariableName: "whatsappId",
    modelApiIdentifier,
    defaultSelection: DefaultReplyButtonSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createReplyButton",
    operationReturnType: "CreateReplyButton",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      replyButton: { required: false, type: "CreateReplyButtonInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultReplyButtonSelection
  },
  {
    type: "action",
    operationName: "bulkCreateReplyButtons",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateReplyButtonsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultReplyButtonSelection
  },
  {
    type: "action",
    operationName: "updateReplyButton",
    operationReturnType: "UpdateReplyButton",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      replyButton: { required: false, type: "UpdateReplyButtonInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultReplyButtonSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateReplyButtons",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateReplyButtonsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultReplyButtonSelection
  },
  {
    type: "action",
    operationName: "deleteReplyButton",
    operationReturnType: "DeleteReplyButton",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteReplyButtons",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertReplyButton",
    operationReturnType: "UpsertReplyButton",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      replyButton: { required: false, type: "UpsertReplyButtonInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateReplyButtonResult": { hasReturnType: false },
      "... on UpdateReplyButtonResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultReplyButtonSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertReplyButtons",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertReplyButtonsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultReplyButtonSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "replyButtonGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ReplyButtonManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultReplyButtonSelection,
  operations
);
export {
  DefaultReplyButtonSelection,
  ReplyButtonManager
};
//# sourceMappingURL=ReplyButton.js.map
